import { useTranslation } from "react-i18next";

export default function SpoedInfo() {
  const { t } = useTranslation("inbraakschade-reparatie");
  const cards = t("spoedInfo.cards", { returnObjects: true }) as Array<{
    title: string;
    text: string;
  }>;

  const icons = [
    "ri-time-line",
    "ri-24-hours-line",
    "ri-truck-line",
    "ri-shield-check-line",
  ];

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("spoedInfo.h2")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className="bg-white border border-brand-border rounded-2xl p-6 md:p-8 text-center hover:border-brand-yellow transition-colors"
            >
              <div className="w-12 h-12 rounded-full bg-brand-yellow flex items-center justify-center mx-auto mb-5">
                <i className={`${icons[i]} text-brand-text text-xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-geist font-bold text-lg text-brand-text mb-2">
                {card.title}
              </h3>
              <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                {card.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}